module.exports = __webpack_public_path__ + "static/media/2.6a438b9e.png";